import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { SubscriberTasksModule } from 'store/modules/subscriber-tasks/subscriberTasksModule';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import SubscriberTask from 'components/subscriber/employee-profile/SubscriberTask';
import { EMPLOYEE_PROFILE_TEST_IDS } from '../../constants';
import {
  InactiveTasksWrapperStyled,
  NoTasksTitleStyled,
  SectionTitleStyled,
  SubscriberTasksListStyled,
  TasksWrapperStyled,
  SpinnerWrapperStyled,
} from './styles';

interface Props {
  subscriberTasksModule: SubscriberTasksModule;
}

const SubscriberTasks: React.FC<Props> = observer(({ subscriberTasksModule }) => {
  const {
    isLoading,
    showNoActiveTasks,
    activeSubscriberTasks,
    inactiveSubscriberTasks,
    domainData,
    getInitialData,
    getTaskChecklistPresenters,
  } = subscriberTasksModule;

  useEffect(() => {
    void getInitialData();
  }, [domainData.groupId]);

  if (isLoading) {
    return (
      <SpinnerWrapperStyled>
        <OverlaySpinner display size="8rem" overlay="none" />
      </SpinnerWrapperStyled>
    );
  }

  return (
    <>
      {showNoActiveTasks && (
        <NoTasksTitleStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.NO_ACTIVE_TASKS_MESSAGE}>
          No Active Tasks
        </NoTasksTitleStyled>
      )}

      {activeSubscriberTasks.length > 0 && (
        <TasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.ACTIVE_TASKS_SECTION}>
          <SubscriberTasksListStyled>
            {activeSubscriberTasks.map((task) => (
              <SubscriberTask
                key={task.entityId}
                task={task}
                checklistOptions={getTaskChecklistPresenters(task.entityId)}
              />
            ))}
          </SubscriberTasksListStyled>
        </TasksWrapperStyled>
      )}

      {inactiveSubscriberTasks.length > 0 && (
        <InactiveTasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.INACTIVE_TASKS_SECTION}>
          <SectionTitleStyled>Inactive Tasks</SectionTitleStyled>
          <SubscriberTasksListStyled>
            {inactiveSubscriberTasks.map((task) => (
              <SubscriberTask
                key={task.entityId}
                task={task}
                checklistOptions={getTaskChecklistPresenters(task.entityId)}
              />
            ))}
          </SubscriberTasksListStyled>
        </InactiveTasksWrapperStyled>
      )}
    </>
  );
});

export default SubscriberTasks;
